{
  "title": "Demos is now Open Source",
  "shortTitle": "Demos is now Open Source",
  "subtitle": "After almost three years as a paid resource, all 110+ React Native animations are now completely open source",
  "author": "Enzo Manuel Mangano",
  "date": "2025-09-23",
  "slug": "open-sourcing-demos",
  "tags": ["open-source", "community", "announcement"],
  "featuredImage": "./images/header.webp",
  "series": "thoughts"
}
